import { Injectable } from '@angular/core';
import FetrapiEnums from '../enum/enums';

@Injectable({
  providedIn: 'root'
})
export class AppStateService {
  loadedNotifications: boolean = false;
  policies: Map<string, FetrapiEnums.MainGroups[]>;

  constructor() {
    this.policies = new Map<string, FetrapiEnums.MainGroups[]>();
    this.policies.set('FetrapiAdmin', [FetrapiEnums.MainGroups.FetrapiAdmin, FetrapiEnums.MainGroups.SuperUser]);
    this.policies.set('FetrapiMember', [FetrapiEnums.MainGroups.FetrapiMember, FetrapiEnums.MainGroups.SuperUser]);
    this.policies.set('ADCRMember', [FetrapiEnums.MainGroups.ADCRMember, FetrapiEnums.MainGroups.SuperUser]);
    this.policies.set('ChIIIMember', [FetrapiEnums.MainGroups.ChIIIMember, FetrapiEnums.MainGroups.SuperUser]);
    this.policies.set('SuperUser', [FetrapiEnums.MainGroups.SuperUser]);
    this.policies.set('ZOIPolicy', [FetrapiEnums.MainGroups.ADCRMember, FetrapiEnums.MainGroups.ChIIIMember, FetrapiEnums.MainGroups.SuperUser]);
    this.policies.set('AdminPage', [FetrapiEnums.MainGroups.FetrapiAdmin, FetrapiEnums.MainGroups.SuperUser]);
    this.policies.set('GridPage', [FetrapiEnums.MainGroups.FetrapiMember, FetrapiEnums.MainGroups.FetrapiAdmin, FetrapiEnums.MainGroups.SuperUser]);
    this.policies.set('ZOIPage', [FetrapiEnums.MainGroups.ADCRMember, FetrapiEnums.MainGroups.ChIIIMember, FetrapiEnums.MainGroups.SuperUser]);
  }

}
